import { createFileRoute } from "@tanstack/react-router";
import { pageHead } from "../utils/page-title";

export const Route = createFileRoute("/gifts")({
  head: () => pageHead("64 Human Design Gifts", { canonicalPath: "/gifts" }),
});
